"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20TokenContract = void 0;
const contracts_1 = require("@etherspot/contracts");
const internal_contract_1 = require("./internal.contract");
class ERC20TokenContract extends internal_contract_1.InternalContract {
    constructor() {
        super(contracts_1.ContractNames.ERC20Token);
    }
}
exports.ERC20TokenContract = ERC20TokenContract;
